import { traitButton } from './shared';
import { CMD_OPEN_ICON_SELECTOR } from './../../const/commands';

export const IconSelector = function(editor, options:any = {}) {
    return {
        name: options.name,
        noLabel: true,
        templateInput: '',
        getInputEl() {
            return traitButton({
                editor: editor,
                buttonText: 'Icon',
                command: CMD_OPEN_ICON_SELECTOR
            });
        }
    }
}